import { environment } from '../../../../environments/environment';

import { MediaApi} from '../../../api/contentLibrary/models/content-library-media.api.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';
import { UserNoteModel } from '../../../Common/Misc/models/user-note.model';


export class MediaModel extends BaseModel <MediaModel, MediaApi> {

    id: any;
    name: string;
    url: string;
    mimeType: string;
    size: number;
    accessType: 'Public';
    approvedByUserIds?: number[];
    libraryIds: number[];
    notes: UserNoteModel[];
    createdDate: string;
    createdByUserId?: number;
    // front-end only
    isSelected: boolean;
    uploadedBy: string;

    get fileType(): string {
        return this.mimeType ? this.mimeType.split('/').pop() : '';
    }

    constructor(apiModel?: MediaApi) {

        super();

        if (apiModel) {
            this.constructFromApiModel(apiModel);

        } else {
            this.constructDefault();
        }

    }
    toApiModel(): MediaApi {
        return {
            id: this.id,
            name: this.name,
            url: this.url,
            mimeType: this.mimeType,
            size: this.size,
            accessType: this.accessType,
            approvedByUserIds: this.approvedByUserIds,
            libraryIds: this.libraryIds,
            notes: this.notes.map(x => x.toMediaNoteApiModel()),
        };
    }
    clone(): MediaModel {
        return new MediaModel(this.toApiModel());
    }
    equals(other?: MediaModel): boolean {
        if (!other) {
            return false;
        }
        return JSON.stringify(this.toApiModel()) === JSON.stringify(other.toApiModel());
    }
    constructFromApiModel(apiModel: MediaApi): void {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.url = apiModel.id ? `${environment.contentLibraryUrl + apiModel.id}` : null;
        this.mimeType = apiModel.mimeType;
        this.size = apiModel.size;
        this.accessType = apiModel.accessType;
        this.approvedByUserIds = apiModel.approvedByUserIds;
        this.createdDate = apiModel.createdDate || new Date().toString();
        this.libraryIds = apiModel.libraryIds;
        this.notes = apiModel.notes?.map(x => new UserNoteModel({
            id: x.id,
            createdUserId: x.createdUserId,
            creationDate: new Date(x.createdDate).getTime(),
            value: x.note
        }));
    }
    constructDefault(): void {
        this.id = null;
        this.name = null;
        this.url = null;
        this.mimeType = null;
        this.size = null;
        this.accessType = null;
        this.approvedByUserIds = null;
        this.libraryIds = null;
        this.notes = null;
        this.createdDate = null;
    }
}


